import { useParams } from "react-router-dom";

const useClientId = () => {
  const urlParams = useParams();
  const clientId = urlParams?.clientId ? parseInt(urlParams?.clientId) : null;

  return {
    clientId,
  };
};
export default useClientId;
